import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth-service/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  isLogin: boolean = false;

  constructor(
    private authSrv: AuthService,
    private location: Location,
    private router: Router,
  ) {
    this.isLogin = !!this.authSrv.getAccessToken();
  }

  goBack() {
    if (this.isLogin) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/unauthorized');
      this.authSrv.removeAccessParam();
    }
  }
}
